
import FinAgentStockDetailsList from '@/components/finagent/FinAgentStockDetailsList';
import FinAgentChartList from '@/components/finagent/FinAgentChartList';
import FinAgentNewsList from '@/components/finagent/FinAgentNewsList';
import { widgetKeys } from "@/constants/finAgent";

export default {
    name: 'SectorWidgetsContainer',

    components: {
        FinAgentStockDetailsList,
        FinAgentChartList,
        FinAgentNewsList,
    },

    props: {
        widgets: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: true,
        }
    },

    computed: {
        stockDetailsWidgetConfigurations() {
            return this.widgets.filter(w => w.widget === widgetKeys.stockDetails);
        },
        chartWidgetConfigurations() {
            return this.widgets.filter(w => w.widget === widgetKeys.chart && w.comparisons?.length > 0);
        },
        newsWidgetConfigurations() {
            return this.widgets.filter(w => w.widget === widgetKeys.news);
        },
    },
}
